export function isAccessDenied(result) {
    return (result?.AccessDenied != null ||
        result?.accessDenied != null);
}
//# sourceMappingURL=types.js.map